import {AfterContentInit, AfterViewChecked, AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatInput} from '@angular/material';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {FormControl, Validators} from '@angular/forms';
import {Contract} from '../../model/Entities/Contract';
import {ContractItemTransfer} from '../../model/Entities/ContractItemTransfer';
import {ContractItem} from '../../model/Entities/ContractItem';
import {ContractItemsListComponent} from '../ContractItemsListComponent/contract-items-list.component';
import {positiveNumberValidator} from '../../validators/positiveNumber.validator';
import {intValidator} from '../../validators/int.validator';
import {ProductContractItem} from '../../model/Entities/ProductContractItem';

@Component({
    selector: 'single-contract-item-transfer-dialog',
    templateUrl: './single-contract-item-transfer.dialog.component.html',
    styleUrls: ['./single-contract-item-transfer.dialog.component.scss']
})
export class SingleContractItemTransferDialogComponent implements AfterViewInit {

    @ViewChild('countInput') countInput: ElementRef;

    public contractItem: ContractItem = new ProductContractItem();
    public direction: any;
    public count = 0;

    countFC = new FormControl('', [
        Validators.required,
        intValidator()
    ]);

    constructor(public dialog: MatDialogRef<SingleContractItemTransferDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.contractItem = data.contractItem;
        this.direction = data.direction;

        if (this.direction === ContractItemTransfer.OUT) {
            this.countFC.setValidators([Validators.required, intValidator]);
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.countInput.nativeElement.select();
            this.countInput.nativeElement.focus();
        }, 100);
    }

    checkValidity(): boolean {
        // console.log(this.contractItem);
        // console.log(this.contractItem.returned + +this.count);
        return ((this.direction === ContractItemTransfer.OUT && (this.count >= -this.contractItem.dispatched))
            || (this.direction === ContractItemTransfer.IN && this.count <= this.contractItem.dispatched - this.contractItem.returned
                && this.contractItem.returned + +this.count >= 0))
            && this.countFC.valid;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/SingleContractItemTransferDialogComponent/single-contract-item-transfer.dialog.component.ts